export default __webpack_public_path__ + "static/media/MINUTA_CONTRATUAL_SP.841d1f80.pdf";